import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryLetterItem from "../../items/glossaryScreen/GlossaryLetterItem";

export default function GlossaryLettersList({terms, filteredTerms, scrollToLetter}) {
    // Used in GlossaryContent as a shortcut to specific letter related content

    // BUILD
    if (isNullOrUndefined(terms) || isNullOrUndefined(scrollToLetter))
        return null
    return (
        <div className={"flex justify-start space-x-[8px]"}>
            {Object.keys(!isNullOrUndefined(filteredTerms) ? filteredTerms : terms).map((letter) => (
                <GlossaryLetterItem key={letter}
                                    letter={letter}
                                    scrollToLetter={() => scrollToLetter(letter)} />
            ))}
        </div>
    );
}